var map = {
	"./AureaToken.PNG": 5270,
	"./EnduraToken.PNG": 5141,
	"./FortisToken.PNG": 1505,
	"./LogicaToken.PNG": 4269,
	"./UmbriaToken.PNG": 5828,
	"./VigesToken.PNG": 7878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4884;